// axios nao pega a autorizacao, nao dá para usar 
// estudar se for o caso
// CANCELADO da api nao pega o teste de response, voltei
// vou ter que usar os dois
import axios from "axios"
import Baseurlaxios from "../../../services/baseurlaxios"

import BaseurlApi from "../../../services/baseurlapi"

import { toastr } from "react-redux-toastr"

import api from "../../../services/api"

export async function getData(codigoPuxada) {

    return  (dispatch) => { 
        
         axios.get(`${BaseurlApi}/GetStock?codigoPuxada=${codigoPuxada}`, {
            //withCredentials: true,
            // auth: {
            //     username: 'usuario',
            //     password: 'password'
            // },

            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        }) 
            .then(response => {
                dispatch({
                    type: "GET_DATA_STOCK",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro StockActions getData: " + error)
            })
    };
}

export async function enviaRegistros(arraystock, codpuxada, usuario) {

    return (dispatch) => {
        api.post(`/Tb_Log_Envio_Stock/IncluiLogStok?CodPuxada=${codpuxada}&Usuario=${usuario}`
        , {
            "ArrayCodCatite": arraystock
          }
                   
        )
            .then(response => {
                dispatch([
                    getData(0)
                ])
                dispatch([
                    getData(codpuxada)
                ])
            })
            .catch(error => {
                toastr.error("Erro StockActions enviaRegistros: " + error.statusText)
            })
    }
}

export function getDataTdsRevendas() {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/Tb_Dist/TodosDist`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_LSTRVD",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro StockActions getDataTdsRevendas: " + error)
            })
    };
}



// Inicia state Modal
export function getDataTodosUsuarioslogStock(CodPuxada) {
    
    return (dispatch) => {
        api.get(`/Tb_Log_Envio_Stock/UsuRevLogStock?CodPuxada=${CodPuxada}`)
            .then(response => {
                dispatch({
                    type: "GET_DATA_LSTUSUREVENDA",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro StockActions getDataTodosUsuarioslogStock: " + error)
            })
    };
}

export function GetLogs(codPuxada
     , BooUsaData
    , DatIni
    , DatFim
    , StrUsu
    , Tipo_Envio
    , IntCodRetorno
    , IntPend_Proc
    )
  
    {
    return (dispatch) => {
        api.get(`/Tb_Log_Envio_Stock/BuscaLogsStock?codPuxada=${codPuxada}&BooUsaData=${BooUsaData}&DatIni=${DatIni}&DatFim=${DatFim}&StrUsu=${StrUsu}&Tipo_Envio=${Tipo_Envio}&IntCodRetorno=${IntCodRetorno}&IntPend_Proc=${IntPend_Proc}`)
            .then(response => {
                dispatch({
                    type: "GET_DATA_BUSCALOG",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro StockActions GetLogs: " + error)
            })
    };
}
// Fim state Modal  


// const express = require('express');
// const cors = require('cors');
// const app = express()

//  app.use(cors());

//  app.use((req, res, next) => {
//      console.log("acessou o middlew")     ;
//      app.use(cors());
//      next();
//  });

// //const BASE_URL_PRODUCAO = "https://cors-anywhere.herokuapp.com/producao.flag.com.br/Flag.Heishop.WebApi/api"

// axios.post('http://localhost:3000/getToken',  {username : "user", password : "password"})
//   .then(resp => {
//       console.log(resp.data.data.authorization)
//   })
//   .catch(error => {
//       console.log(error)
//   })
